/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ProductPriceUpdateNotification.tsx
 *
 * Project Title :  Checkout
 *
 * Description	: UT test cases for ProductAddedNotification.tsx
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422336
 *
 * @Date		 : Oct 15 2020
 *
 * @Version      : Version 1.0
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
*******************************************************************************/

import React from 'react';
import { Notification } from '@scuf/common';
import { CheckoutUILabels } from '../constants/checkout-constants';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import RouteConstants from '../constants/route-constants';
import ProductAlertActions from '../redux/actions/products-alerts-action';

interface IToast {
    closeToast: any;
    hideAlert: Function;
}

class ProductPriceUpdateNotification extends React.Component<IToast & RouteComponentProps> {
    constructor(props: IToast & RouteComponentProps) {
        super(props);
        this.handleCartLink = this.handleCartLink.bind(this);
    }

    handleCartLink() {
        this.props.history.push(RouteConstants.MY_CART);
    }

    render() {
        return (
            <React.Fragment>
                <Notification
                    className="toast-notification product-change"
                    hasIcon={true}
                    title={CheckoutUILabels.PRODUCT_PRICE_UPDATE}
                    severity="important"
                    detailsText="View Cart"
                    onDetailsClick={this.handleCartLink}
                    onCloseClick={this.props.closeToast}
                >
                    {CheckoutUILabels.PRODUCT_PRICE_UPDATE_MSG}
                </Notification>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    hideAlert: ProductAlertActions.hideAlert,
};

export default connect(null, mapDispatchToProps)(withRouter(ProductPriceUpdateNotification));
